module.exports = __webpack_public_path__ + "static/media/ansif.714b16f0.jpg";